<template>
  <h1>Help</h1>
</template>

<script>
export default {
  name: 'Help'
};
</script>

<style>
</style>